import { ETextInputTypes, ETextStyleVariant, Text, TextInput } from '@outdoorsyco/bonfire';
import { clsx } from 'clsx';
import React, { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ITripDistanceInfo } from './types';

type TEstimatedTripDistanceSelectorProps = {
  onTripDistanceChange: (info: ITripDistanceInfo) => void;
  initialTripDistanceInfo?: ITripDistanceInfo;
  centerTitle?: boolean;
};

const EstimatedTripDistanceSelector: React.FC<TEstimatedTripDistanceSelectorProps> = ({
  onTripDistanceChange,
  initialTripDistanceInfo,
  centerTitle,
}) => {
  const intl = useIntl();

  const [tripDistance, setTripDistance] = useState<string>(() => {
    return initialTripDistanceInfo?.estimatedTripDistance !== undefined
      ? String(initialTripDistanceInfo.estimatedTripDistance)
      : '';
  });

  const handleChangeTripDistance = useCallback(
    (value: string) => {
      setTripDistance(value);
      onTripDistanceChange({
        estimatedTripDistance: value ? Number(value) : undefined,
      });
    },
    [onTripDistanceChange],
  );

  const label = intl.formatMessage({
    defaultMessage: 'Estimated total miles',
    id: 'e/0CjL',
    description: 'Guided Search > Trip distance input label',
  });

  return (
    <div className="flex flex-col p-4 mt-6 border rounded-lg gap-4 bg-neutral-05 border-neutral-20">
      <div className="flex flex-col gap-1">
        <Text
          variant={ETextStyleVariant.LargeBold}
          className={clsx('text-base font-medium semiHighlight text-primary-base', {
            'text-center': centerTitle,
          })}>
          <FormattedMessage
            defaultMessage="Trip distance"
            id="FhJx8A"
            description="Guided Search > Trip distance section heading"
          />
        </Text>
      </div>

      <TextInput
        controlled
        type={ETextInputTypes.Number}
        name="trip-distance"
        label={label}
        ariaLabel={label}
        inputValue={tripDistance}
        onChange={handleChangeTripDistance}
        showClearButton
      />
    </div>
  );
};

export default EstimatedTripDistanceSelector;
